import { useAppContext } from '@contexts/app';
import { useWebsocketContext } from '@contexts/websocket';
import { localStore } from '@utils/localStore';
import { initialState } from '@contexts/app/constants';
import { useQueryClient } from '@tanstack/react-query';

export const useLogout = () => {
  const { setData } = useAppContext();
  const { ws } = useWebsocketContext();

  const queryClient = useQueryClient();

  return (type: 'admin' | 'user') => {
    queryClient.removeQueries();
    ws?.disconnect();
    if (!localStore.getItem('app-impersonate')) localStore.removeItem(`app-${type}`);
    else {
      localStore.removeItem('app-user');
      localStore.removeItem('app-admin');
    }
    localStore.removeItem('app-foreman');
    localStore.removeItem('app-impersonate');
    if (type === 'admin') setData((prev) => ({ ...prev, admin: initialState.admin }));
    else setData((prev) => ({ ...initialState, ...prev.admin }));
  };
};
